module.exports = __webpack_public_path__ + "img/delete-icon.5e2fca96.svg";